import React from "react"
import { Id, OperationsContainer, OrderLineInfo, Reason } from "./Shared.styled"
import { OrderRelease } from "lib/types/generated/graphql-types"
import Money from "../../../Money"
import DineroFactory from "dinero.js"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  release: OrderRelease
  currencyCode: string
  orderLineId: string
}

const ReleaseInfo = ({ release, currencyCode, orderLineId }: Props) => {
  const { switchToUpdatesTab } = useOrderTabContext()

  const releasedQuantity = release?.orderLines?.find(
    (ol) => ol.orderLineId === orderLineId
  )?.quantity

  return (
    <OperationsContainer>
      <div>
        <b>Release</b>{" "}
        <div>
          {release?.reason && (<Reason>{release?.reason?.code} - {release?.reason?.cause}</Reason>)}
        </div>{" "}
        <Id onClick={switchToUpdatesTab}>{release.id}</Id>
      </div>{" "}
      <div>
        <OrderLineInfo>
          <div>Quantity:</div>
          <div>
            {releasedQuantity}
          </div>
        </OrderLineInfo>
        <OrderLineInfo>
          <div>Release payment:</div>
          <div>
            {"-"}
            <Money
              amount={release?.orderLines?.find(ol => ol.orderLineId === orderLineId)?.totalAmount ?? 0}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
          </div>
        </OrderLineInfo>
      </div>
    </OperationsContainer>
  )
}

export default ReleaseInfo
